module.exports = "./app-dist/templates/queue.directive.f7b96f0dbd568c7222f7a7e8e8cadd68.html";